import { render, staticRenderFns } from "./DominantFrequencyCard.vue?vue&type=template&id=18471058"
import script from "./DominantFrequencyCard.vue?vue&type=script&lang=js"
export * from "./DominantFrequencyCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports